import { styled } from "@mui/material/styles";
import Stack from "@mui/material/Stack";
import Box from "@mui/material/Box";
import Image from "next/image";
import React, { forwardRef, memo, useEffect } from "react";
import { theme } from "../../../Theme/Theme";
import { IWithLazyLoadProps, withLazyLoad } from "../../../../hooks/withLazyLoad";
import { EEDAnimation } from "@trailblazer-game/ed-webkit";
import useMediaQuery from "@mui/material/useMediaQuery";

interface IHomeCarouselProps extends IWithLazyLoadProps {
  className?: string;
  images: string[];
  imageAspectRatio?: string;
}

const HomeCarousel = memo(forwardRef(({ className, images, isVisible }: IHomeCarouselProps, ref) => {
  const [ visible, setVisible ] = React.useState(false);
  const isMedium = useMediaQuery(theme.breakpoints.down("md"));

  useEffect(() => {
    if (visible) {
      return;
    }
    setVisible(isVisible);
  }, [ isVisible ]);

  return <Stack className={className} direction={isMedium ? "column" : "row"} alignItems={"center"} justifyContent={"center"} spacing={8}
                ref={ref}>
    {visible &&
      images.map((image, index) =>
        <Box className={`image ${EEDAnimation.ScaleInCenter}`} key={index} sx={{
          animationDelay: `${index * 0.25}s !important`,
        }}>
          <Image src={image} layout={"fill"}/>
        </Box>
      )
    }
  </Stack>;
}));

HomeCarousel.displayName = "HomeCarousel";

const HomeCarouselStyled = styled(HomeCarousel)((props) => ({
  position: "relative",
  zIndex: 10,
  background: "linear-gradient(90deg,rgba(255,255,255,0),rgba(255,255,255,.2) 30%,rgba(255,255,255,.2) 60%,rgba(255,255,255,0))",
  width: "100%",
  maxWidth: "1440px",
  padding: theme.spacing(4, 8),
  minHeight: "300px",
  ".image": {
    position: "relative",
    display: "inline-flex",
    aspectRatio: props.imageAspectRatio || "0.714",
    flexGrow: 1,
    height: "100%",
    animationDuration: "1s"
  },
  [theme.breakpoints.down("md")]: {
    background: "linear-gradient(90deg,rgba(255,255,255,0),rgba(255,255,255,.2) 10%,rgba(255,255,255,.2) 90%,rgba(255,255,255,0))",
    ".image": {
      width: "100%",
      height: "auto"
    }
  }
}));

// Export
export default withLazyLoad(HomeCarouselStyled);